import {useEffect} from 'react';
import resetSession from 'utils/functions/resetSession';

export function useCrossDomainLogout() {
  const allowedOrigins = [
    'https://backoffice.letrus.com.br',
    'https://backoffice.beta.letrus.com.br',
  ];

  useEffect(() => {
    const handleMessage = (event) => {
      if (allowedOrigins.includes(event.origin)) {
        if (event.data === 'logout') {
          resetSession();

          event.source?.postMessage('logout_successful', event.origin);
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);
}
